export const webLinks = {
  PBP_REFERENCE: 'https://reference.poweredbypercent.com',
  PBP_WEBSITE: 'https://poweredbypercent.com/',
  HELP_CENTER: 'https://help.goodstack.org/hc/en-us'
}
